<angular-editor
  [id]="id"
  [ngModel]="content"
  (ngModelChange)="onContentChange($event)"
  [config]="config"
  [ngModelOptions]="{ standalone: true }"></angular-editor>
